<style>
  .cart-table {
    border: 0px solid #dfe6ec;
  }

  .cart-table td, .el-table th.is-leaf {
    border-bottom: 0px solid #dfe6ec;
  }

  .cart-table tbody tr td {
    border-top: 1px solid #dfe6ec;
    border-bottom: 1px solid #dfe6ec;
  }

  .cart-table tbody tr td:nth-of-type(1) {
    border-left: 1px solid #dfe6ec;
  }

  .cart-table tbody tr td:nth-of-type(7) {
    border-right: 1px solid #dfe6ec;
  }

  .cart-table th .cell {
    color: #666666;
    font-size: 14px;
  }

  .cart-table thead tr th:nth-of-type(1) .cell {
    display: none;
  }

  .cart-table thead tr {
    background-color: #f4f4f4;
  }

  .cart-table tr {
    margin-bottom: 100px;
  }

  .cart-table table {
    border-collapse: separate;
    border-spacing: 0px 10px;
  }

  .cart-table::after {
    width: 0px;
  }

  .cart-table::before {
    height: 0px;
  }

  .fix-bottom{
    border: 1px solid #e0e6ed;
    display: flex;
    justify-content:space-between;
    padding-left: 14px;
    position: fixed;
    bottom: 0px;
    background: #fff;
    width: 1160px;
    z-index: 10000;
  }

  .bottom{
    border: 1px solid #e0e6ed;
    width: 100%;
    display: flex;
    justify-content:space-between;
    padding-left: 14px;
    z-index: 10000;
  }
</style>
<template>
  <div>
    <div v-if="this.carts.length === 0"
         style="display: flex;justify-content: center;margin-top: 100px;margin-bottom: 100px;">
      <img src="../assets/cart_empty.png"/>
      <div style="display: flex;justify-content: center;flex-direction: column; margin-left: 24px">
        <p>你的购物车什么都没有奥!</p>
        <router-link :to="{name:'home'}" style="margin-top: 5px"><span class="gl-txt-blue">去购物</span></router-link>
      </div>
    </div>
    <div v-else>
      <el-table class="cart-table"
                ref="multipleTable"
                :data="carts"
                style="width: 100%"
                @cell-mouse-enter="handleCellEnter"
                @cell-mouse-leave="handleCellLeave"
                @selection-change="handleSelectionChange" v-if="isRender">
        <el-table-column
          type="selection"
          width="50">
        </el-table-column>
        <el-table-column
          inline-template
          label="商品信息"
          width="420">
          <div>
            <el-row style="height: 110px; display: flex">
              <el-col :span="5" style="height: 100%; display: table;">
                <div style="width: 100%;
                                        height: 100%;
                                        display: table-cell;
                                        vertical-align: middle;">
                  <img :src="row.product.cover | cdn-filter"
                       style="width: 100%;
                                            display: table-cell;
                                            vertical-align: middle;">
                </div>
              </el-col>
              <el-col :span="19" style="height: 100%; display: table;">
                <div style="width: 100%;
                                        height: 100%;
                                        display: table-cell;
                                        vertical-align: middle;
                                        padding-left: 10px;">
                  <p style="line-height: 16px; margin-bottom: 5px;">
                    {{ row.product.name }}
                </p>
                  <p style="font-size: 13px; line-height: 15px; color: #aaa;">
                    区域：{{ row.region }}
                </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-table-column>
        <el-table-column
          inline-template
          label="单价">
          <div style="color: #ed1b1e;">&yen;
            <span>{{ row.product.unitPrice }}</span>
          </div>
        </el-table-column>
        <el-table-column
          inline-template
          label="数量">
          <div>
            <span>{{row.amount}}</span>
          </div>
        </el-table-column>
        <el-table-column
          inline-template
          label="补差价">
          <div>
            <span>{{row.premium}}</span>
          </div>
        </el-table-column>
        <el-table-column
          inline-template
          label="小计"
          width="200">
          <div style="color: red;">
            &yen;
            <span>{{ row | subTotalPriceFilter }}
            <span style="font-size: 13px;" v-show="row.premium > 0"> ( &plus; {{ row.premium.toFixed(2) }} ) </span>
            <span style="font-size: 13px;" v-show="row.premium < 0"> (  {{ row.premium.toFixed(2)
              }} ) </span>
            </span>
          </div>
        </el-table-column>
        <el-table-column
          inline-template
          property="action"
          label="操作">
          <div>
            <el-button style="color:#999999; font-size: 14px " type="text" size="small"
                       @click="deleteCart($index)">删除

            </el-button>
          </div>
        </el-table-column>
      </el-table>
      <div class="flex"  style="flex-direction:column;align-items: center" v-if="isLoading">
        <lh-loading style="margin-top: -80px;margin-bottom: -80px;"></lh-loading>
        <span class="txt-grey" style="font-size: 16px;margin-bottom: 10px">加载更多</span>
      </div>
      <div class="cart_pay_bottom_top flex" >

      </div>
      <div class="cart_pay_bottom" v-bind:class="{'fix-bottom': payBottomFix, 'bottom': !payBottomFix}">
        <div>
      <span class="el-checkbox__input" v-bind:class="{'is-checked': isAllChecked}" @click="toggleSelection1()">
        <span class="el-checkbox__inner"></span>
        <input type="checkbox" class="el-checkbox__original" value="">
      </span>
          <el-button type="text"
                     size="large"
                     property="action"
                     :disabled="isNoneChecked"
                     @click="deleteByBatch"
                     style="color: #ea1717;margin-left: 30px">删除

          </el-button>
        </div>
        <div>
          <span style="font-size: 14px; margin-right: 30px; color:#999999;">
                已选择{{ amountOfSelection }}件商品，合计：
                <span style="color: #eb2828; font-size: 20px;">
                    &yen;{{ totalPrice }}
                </span>
            </span>
          <el-button type="primary"
                     size="large"
                     :disabled="isNoneChecked"
                     @click="checkout"
                     style="border-radius: 0; width: 130px" class="gl-bg-blue">去结算

          </el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data () {
      return {
        isLoading:false,
        payBottomFix: false,
        multipleSelection: [],
        currentAmount: null,
        isRender: true,
        page:1,
      }
    },
    props: {
      carts: Array,
      isLast: false,
    },
    computed: {
      amountOfSelection () {
        return this.multipleSelection.length
      },
      isAllChecked() {
        return this.amountOfSelection >= this.carts.length
      },
      isNoneChecked(){
        return this.amountOfSelection === 0
      },
      totalPrice () {
        let r = 0
        for (let i of this.multipleSelection) {
          let _product = i.product;
          r += i.amount * _product.unitPrice + i.premium;
        }
        return r.toFixed(2)
      },
    },
    watch: {
      'isLoading':function (isLoading) {
//          加载跟多
          if (isLoading && !this.isLast){
            this.$emit('loading', ++this.page);
          }
      },
      'carts':function () {
         this.isLoading = false;
//         this.clearSelection();
      }
    },
    methods: {
      handleBottomScroll (document) {
        var self = this;
        let documentHeight = $(window).height();
        let scrollHeight = $(document).scrollTop();
        let bottomTop = $(".cart_pay_bottom_top").offset().top;
//           console.log("documentHeight=" + documentHeight);
//           console.log("scrollHeight=" + scrollHeight);
//           console.log("bottomTop=" + bottomTop);
//          console.log(documentHeight + scrollHeight - bottomTop);
        if (documentHeight + scrollHeight > bottomTop + 42){
          if (self.payBottomFix){
            self.payBottomFix = false;
            if (!self.isLast) self.isLoading = true;

          }
        } else {
          if (!self.payBottomFix){
            self.payBottomFix = true;
          }
        }
      },

      toggleSelection1() {
        this.carts.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      },
      handleSelectionChange (val) {
        this.multipleSelection = val
      },
      deleteByBatch () {
        let vm = this
        let selectedIds = this.multipleSelection.map(c => c.id)
        vm.$store.dispatch('removeCartByBatch',
          {
            carts: selectedIds
          }).then(
          data => {
//            debugger
            let nextCarts = vm.carts.filter(c => selectedIds.indexOf(c.id) < 0)
            vm.$emit('change', nextCarts)
            this.multipleSelection = []
            this.tipSuccess('删除成功！')
          },
          error => {
            this.tipError(error)
          }
        )
      },
      deleteCart (index) {
        let vm = this
        this.$confirm('确认删除该商品吗？', '删除商品', {
          type: 'warning'
        }).then(() => {
          vm.$store.dispatch('removeCart', vm.carts[index].id).then(
            () => {
              vm.carts.splice(index, 1)
              vm.$emit('change', vm.carts)
              this.tipSuccess('删除成功！')
            },
            () => {
              vm.$message.error('删除失败~')
            }
          )
        }).catch(() => {
        })
      },
      handleCellEnter (row) {
        this.currentAmount = row.amount
      },
      handleCellLeave (row) {
        if (this.currentAmount !== row.amount) {
          this.$store.dispatch('updateCart', row).then(
            () => {
            },
            () => {
            }
          )
        }
      },
      updateCart (index) {
        this.$store.dispatch('updateCart', this.carts[index])
      },
      clearSelection () {
        this.multipleSelection = []
      },
      checkout () {
        this.$store.commit('CHECKOUT', this.multipleSelection)
        this.$router.push({name: 'checkout'})
      },
    },

    beforeCreate(){
      console.log("beforeCreate")
    },
    mounted(){
      let self = this
//      window.addEventListener('scroll', this.handleScroll);
      $(document).scroll(function () {
        self.handleBottomScroll(this)
      })
      $(window).scrollTop(1)
      $(window).scrollTop(-1)
    },

    destroyed(){
      $(document).unbind('scroll')
      console.log("destroyed")
    },
  }
</script>




// WEBPACK FOOTER //
// Cart.vue?4062b789